import "@/App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import EmergencyTips from "./components/EmergencyTips";
import Services from "./components/Services";
import ServiceArea from "./components/ServiceArea";
import Gallery from "./components/Gallery";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App" data-testid="app-container">
      <Header />
      <main>
        <Hero />
        <EmergencyTips />
        <Services />
        <ServiceArea />
        <Gallery />
        <Testimonials />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}

export default App;
